import { AfterViewInit, Component, EventEmitter, Input, Output, SimpleChanges, OnDestroy, OnChanges, ChangeDetectorRef, ViewChildren, QueryList } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InputsModule } from '@progress/kendo-angular-inputs';
import { Input as RouterInput } from '@angular/core';
import { PageService } from 'app/services/page.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { SelectEvent } from '@progress/kendo-angular-charts';
import { DrakeCustomComponentComponent } from 'app/drake-components/drake-custom-component/drake-custom-component.component';
import { GridService } from 'app/services/grid.service';
import { DrakeSharedService } from 'app/services/drake-shared.service';
import { TranslocoPipe } from '@ngneat/transloco';
import { HttpClient } from '@angular/common/http';
import { FormService } from 'app/services/form.service';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { MatIcon } from '@angular/material/icon';
import { DrakeCustomScriptsService } from 'app/services/drake-custom-scripts.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-drake-scope-form',
  templateUrl: './drake-scope-form.component.html',
  styleUrls: ['./drake-scope-form.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    InputsModule,
    TabStripModule,
    DrakeCustomComponentComponent,
    LayoutModule,
    TranslocoPipe,
    MatIcon
  ],
  providers: [TranslocoPipe]
})
export class DrakeScopeFormComponent implements AfterViewInit, OnDestroy, OnChanges {
  @RouterInput() scope!: string;
  @RouterInput() id!: string;
  @Input() forcedScope: string;
  @Input() isDefault: boolean = true;

  @ViewChildren(DrakeCustomComponentComponent) drakeComponents: QueryList<DrakeCustomComponentComponent>;

  private urlBasic: string = 'd';
  public userId: string;

  public subscriptionSave: any;
  public subscriptionSaveDraft: any;
  public approveScopeFormSubject: any;
  public changeTabSubject: any;

  public subscriptionClone: any;
  public subscriptionRoute: any;
  public subscriptionValueChanged: any;

  public pageData: any;
  public baseData: any = {};
  public mainRecord: any = {};

  public selectedTab = null;

  private subPostMessage: Subscription = new Subscription();

  constructor(private activatedRoute: ActivatedRoute, private gridService: GridService,
    private router: Router, private pageService: PageService, private drakeShared: DrakeSharedService,
    private formService: FormService, private drakeScripts: DrakeCustomScriptsService,
    private translocoPipe: TranslocoPipe, private cdRef: ChangeDetectorRef) {


    drakeShared.currentBaseData = this.baseData;

    /*if (!this.router.getCurrentNavigation()?.extras.state?.skipBreadcrumb){
      let previousUrl = this.router.getCurrentNavigation()?.previousNavigation.finalUrl.toString();
      this.drakeShared.addBreadcrumbUrl(previousUrl);
    }*/

    drakeShared.drpOptions = {};

  }
  ngAfterViewInit(): void {

    if (this.id)
      this.id = decodeURIComponent(this.id);
    this.subscriptionSave = this.drakeShared.saveScopeFormSubject.subscribe((redirect) => this.saveDataFunction(redirect));
    this.subscriptionClone = this.drakeShared.cloneScopeFormSubject.subscribe((redirect) => this.cloneDataFunction(redirect));
    this.subscriptionValueChanged = this.drakeShared.valueChangedSubject.subscribe((event) => this.onValueChange(event));
    this.subscriptionSaveDraft = this.drakeShared.saveScopeFormSubjectDraft.subscribe((redirect) => this.saveDataFunction(redirect, true));
    this.approveScopeFormSubject = this.drakeShared.approveScopeFormSubject.subscribe((redirect) => this.saveDataFunction(redirect, null, true));
    this.changeTabSubject = this.drakeShared.changeTabSubject.subscribe((tabCode) => this.selectedTab = tabCode);
    this.subPostMessage = this.drakeShared.postMessages$.subscribe({
      next: (data) => {
        console.log('Componente ha ricevuto:', data);
      },
      error: (err) => console.error('Errore nel flusso messaggi', err)
    });

    console.log("BaseDataScopeFOrm", this.baseData);
    this.loadForm();
    //setInterval(() => console.log("mainRecord interval", this.mainRecord), 2000);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.scope || changes.id || changes.forcedScope) {

      this.drakeShared.addBreadcrumbUrl();

      this.loadForm();
    }
  }


  updateChildren() {
    this.drakeComponents.forEach(f => f.refresh()); // o un metodo che forza il refresh
  }

  loadForm() {

    //setInterval(_ => console.log(this.mainRecord), 5000)

    this.pageData = {};
    this.baseData = {};
    this.mainRecord = {};

    this.subscriptionRoute = this.activatedRoute.params.subscribe(params => {

      if (this.forcedScope) {
        this.urlBasic = 'a';
        this.scope = this.forcedScope;
      }
      var template = params['tpl'];

      this.pageService.getPageByUrl(`${this.urlBasic}/${this.scope}/f/*` + (template ? `/t/${template}` : '')).subscribe((resultPage: any) => {

        this.selectedTab = resultPage.pageTabs[0].tabCode;

        this.formService.getFormAutoAction(this.scope).subscribe(resultAutoActions => {
          console.log('Actions', resultAutoActions.data)
          resultPage.autoActions = resultAutoActions.data;
          this.pageData = resultPage;
          this.drakeShared.currentPageData = resultPage;
          this.subscriptionRoute.unsubscribe();

          var drakeScripts = this.drakeScripts;
          this.drakeShared.currentPageData.pageScripts.forEach(s => {

            eval('drakeScripts[s.scriptCode] = function(args) {' + s.scriptContent + '}');
          });

          this.getMainRecord();
        });

      });

      /*pageService.getPageByUrl(`a/REGISTRATION/f/*`).subscribe((resultPage: any) => {
 
          formService.getFormAutoAction(params?.['scope']).subscribe(resultAutoActions => {
              console.log('Actions', resultAutoActions.data)
              resultPage.autoActions = resultAutoActions.data;
              this.pageData = resultPage;
              drakeShared.currentPageData = resultPage;
 
          });
 
      });*/


    })
  }

  public async saveDataFunction(redirect: boolean, isDraft: boolean = false, overrideEdit: boolean = false): Promise<boolean> {
    // 1. Validazione iniziale
    debugger;

    if (!isDraft) {


      // 3. Salva gli altri scope in parallelo o sequenza
      const allScopes = Object.keys(this.baseData)
      for (const s of allScopes) {

        const records = Object.keys(this.baseData[s]);
        for (const r of records) {

          const invalidFields = this.formService.applyValidation(this.baseData[s][r], s, this.pageData);
          if (invalidFields.length) {
            const notification = this.translocoPipe.transform("notification.error.scopeForm.invalidField");
            this.drakeShared.showTemporaryNotification(notification, 'error');
            return false;
          }

        }
      }


    }

    try {
      // 2. Salva lo scope principale per ottenere l'ID prioritario
      debugger;
      const newId = await this.saveScope(this.scope, isDraft, overrideEdit);

      // 3. Salva gli altri scope in parallelo o sequenza
      const otherScopes = Object.keys(this.baseData).filter(s => s !== this.scope);
      for (const s of otherScopes) {
        await this.saveScope(s, isDraft, overrideEdit, newId);
      }

      // 4. NOTIFICA DI SUCCESSO UNICA
      const successMsg = this.translocoPipe.transform("notification.success.scopeForm.save");
      this.drakeShared.showTemporaryNotification(successMsg, 'success');

      // 5. Gestione Redirect finale
      if (redirect) {
        this.drakeShared.toolbarActions.CLOSEFORM();
      } else if (this.id === "#NEWID#" || !this.id) {
        // Naviga al nuovo record usando l'ID restituito dalla prima chiamata
        const targetId = newId || this.id;
        this.router.navigate([`${location.pathname}/${targetId}`], {
          state: { skipBreadcrumb: true, replaceUrl: true }
        });
      }

      return true;

    } catch (error) {
      // 6. NOTIFICA DI ERRORE UNICA
      console.error("Errore durante il salvataggio:", error);
      const errorMsg = this.translocoPipe.transform("notification.error.scopeForm.save");
      this.drakeShared.showTemporaryNotification(errorMsg, 'error');
      return false;
    }
  }

  private async saveScope(s: string, isDraft: boolean, overrideEdit: boolean, newId?: string): Promise<string | null> {
    const records = Object.keys(this.baseData[s]);
    let lastSavedId = null;

    for (const r of records) {
      // Preparazione dati (logica originale)
      var fields = this.baseData[s][r]; // Usiamo lo scope e record corrente
      if (!fields["_id"]) fields["_id"] = this.id;

      if (newId) {
        Object.keys(fields).forEach(key => {
          if (typeof fields[key] === 'string' && fields[key].includes('#PARENTID#')) {
            fields[key] = fields[key].replace('#PARENTID#', newId);
          }
        });
      }

      for (let k of Object.keys(fields)) {
        const newKey = k.includes('$') ? k.split('$')[1] : k;
        fields[newKey] = fields[k];
      }

      // Eseguiamo il salvataggio solo se necessario
      if (fields._editable || fields._editable === undefined || overrideEdit) {
        // Usiamo firstValueFrom (standard moderno Angular) o toPromise()
        const result: any = await this.gridService.saveScopeData(s, "UPSERT", fields, isDraft).toPromise();

        if (result && result.data && result.data[0]) {
          lastSavedId = result.data[0]._id;
        }
      }
    }
    return lastSavedId;
  }

  public cloneDataFunction(redirect: boolean) {

    var scopes = Object.keys(this.baseData);
    scopes.forEach(s => {
      var records = Object.keys(this.baseData[s]);
      records.forEach((r) => {
        console.log(s + " - " + r);
        this.baseData[s][r].Title = this.baseData[s][r].Title + " - Copia";
        this.gridService.cloneScopeData(s, "UPSERT", this.baseData[s][r]).subscribe((result: any) => {
          console.log(s + " - " + r, result);
          //this.showTemporaryNotification(notification, 'success');
          var notification = this.translocoPipe.transform("notification.success.scopeForm.clone");
          this.drakeShared.showTemporaryNotification(notification, 'success');
          /*if (redirect)
            this.drakeShared.toolbarActions.CLOSEFORM();
          else if (r == "#NEWID#")*/
          var newPath = location.pathname.split("/");
          newPath.pop();
          var newPathString = newPath.join("/");
          this.cdRef.markForCheck();
          this.router.navigate([`${newPathString}/${result.data[0]._id}`], { state: { skipBreadcrumb: true } })

        },
          (err: any) => {
            console.log(err)
            //var notification = this.translocoPipe.transform("notification.error.toolbar.clone");
            //this.showTemporaryNotification(notification, 'error');
            var notification = this.translocoPipe.transform("notification.error.scopeForm.clone");
            this.drakeShared.showTemporaryNotification(notification, 'error');


          });
      });
    })

  }

  public ngOnDestroy() {
    this.pageData = {};
    this.baseData = {};
    this.mainRecord = {};
    if (this.subscriptionSave != null) {
      this.subscriptionSave.unsubscribe();
    };
    if (this.subscriptionClone != null) {
      this.subscriptionClone.unsubscribe();
    };
    if (this.subPostMessage != null) {
      this.subPostMessage.unsubscribe();
    };

    if (this.subscriptionValueChanged != null) {
      this.subscriptionValueChanged.unsubscribe();
    };
    if (this.subscriptionRoute != null)
      this.subscriptionRoute.unsubscribe();
    
    if (this.changeTabSubject != null) {
      this.changeTabSubject.unsubscribe();
    };
  }

  public onValueChange(event: any) {
    //console.log("OnValue changed drake scope");
    if (event.all) {
      setTimeout(_ => {
        this.applyActions(null);
        //this.applyValidation();
        this.drakeShared.editableSubject.next(this.mainRecord._editable != undefined ? this.mainRecord._editable : true);
        this.drakeShared.baseData$.next({});

        //this.cdRef.markForCheck();
      }, 100);
    }
    else {

      setTimeout(_ => {
        //console.log('EVENTO SCHEDA', event);

        var column = event.field;

        this.applyActions(column);
        this.applyValidation(column);
        this.drakeShared.baseData$.next({});
        //this.cdRef.markForCheck();
      }, 100);
    }
  }
  applyActions(columnCode: string, inSaving = false) {
    var actionsToExecute = this.pageData.autoActions?.filter(a =>
      (!columnCode || a.TriggerFields.indexOf(columnCode) >= 0));
    actionsToExecute.forEach(a => {
      //console.log('action', a)
      switch (a.ActionType.value) {
        case 'VISIBLE':
          this.formService.applyStandardAction(this.drakeShared.currentPageData, a, 'visible', this.mainRecord, JSON.parse(localStorage.getItem('user')))
          break;
        case 'REQUIRED':
          this.formService.applyStandardAction(this.drakeShared.currentPageData, a, 'required', this.mainRecord, JSON.parse(localStorage.getItem('user')))
          break;
        case 'READONLY':
          this.formService.applyStandardAction(this.drakeShared.currentPageData, a, 'readonly', this.mainRecord, JSON.parse(localStorage.getItem('user')))
          break;
        case 'VALUE':
          if (inSaving || (a.TriggerFields[0] != '#SAVE' && a.TriggerFields[0] != '#SAVEDRAFT'))
            this.formService.applyStandardAction(this.drakeShared.currentPageData, a, 'value', this.mainRecord, JSON.parse(localStorage.getItem('user')))
          break;
        case 'CUSTOM':
          this.formService.applyCustomAction(this.drakeShared.currentPageData, a, this.mainRecord, JSON.parse(localStorage.getItem('user')));
          break;
        case 'VISIBLE_COMPONENT':
          this.formService.applyStandardAction(
            this.drakeShared.currentPageData,
            a,
            'visible',
            this.mainRecord,
            JSON.parse(localStorage.getItem('user'))
          );
          break;

      }

    });
  }

  applyValidation(column: string | null = null) {

    this.formService.applyValidation(this.mainRecord, this.scope, this.pageData, column)
  }


  getMainRecord() {

    var interval = setInterval(() => {
      //console.log("GETTING MAIN RECORD");
      if (!this.baseData) return;
      var scope = '';
      var id = '';
      if (Object.keys(this.baseData).length == 1) {
        scope = Object.keys(this.baseData)[0];

        if (Object.keys(this.baseData[scope]).length == 1) {
          id = Object.keys(this.baseData[scope])[0];
          this.mainRecord = this.baseData[scope][id];
          for (let k of Object.keys(this.mainRecord)) {
            const newKey = k.includes('$') ? k.split('$')[1] : k;
            this.mainRecord[newKey] = this.mainRecord[k];
          }
          this.drakeShared.mainRecord = this.mainRecord;
          //console.log("MAIN RECORD", JSON.stringify(this.mainRecord));
          //this.drakeShared.editableSubject.next(this.mainRecord._editable!=undefined? this.mainRecord._editable : true);
          clearInterval(interval);

          this.updateChildren();
          //debugger;
          this.applyActions(null);
          return;
        }
      }

      var scope = location.href.split('/d/')[1]?.split('/')[0];


      var id = location.href.split('/f/')[1] || '#NEWID#';
      if (this.baseData[scope] && this.baseData[scope][id] && (this.baseData[scope][id]['_id'] || id == '#NEWID#')) {
        this.mainRecord = this.baseData[scope][id];
        this.drakeShared.mainRecord = this.mainRecord;
        console.log("MAIN RECORD", this.mainRecord);
        //this.drakeShared.editableSubject.next(this.mainRecord._editable!=undefined? this.mainRecord._editable : true);
        clearInterval(interval);

      }
      return;
    }, 1000);


    /*setInterval(()=> {
  
      console.log("ThisBaseData" ,this.baseData);
  
    },1000);*/

  }

  public onTabSelect(e: SelectEvent, tabCode:string): void {
    console.log(e);
    this.selectedTab = tabCode;
  }


  ngOnInit(): void {
  }

}
